// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as PervasivesU from "rescript/lib/es6/pervasivesU.js";
import * as DomEl$GameDataCore from "../DomEl.res.mjs";
import * as Menus$GameDataCore from "../Menus.res.mjs";
import * as Styles$GameDataCore from "../Styles.res.mjs";
import * as Throttle$GameDataCore from "../Throttle.res.mjs";

var focusableSelector = "input:not([disabled]):not([tabindex=\"-1\"]):not(.hidden), button:not([disabled]):not([tabindex=\"-1\"]):not(.hidden), a:not([disabled]):not([tabindex=\"-1\"]):not(.hidden)";

var typeableCharacters = "abcdefghijklmnopqrstuvwxyz0123456789";

function requireElement(parent, selector, label, selectId) {
  var found = parent.querySelector(selector);
  if (!(found == null) && DomEl$GameDataCore.isHtmlElement(found)) {
    return found;
  }
  return PervasivesU.failwith(label + " is not an HTML element for select with id " + selectId);
}

function mounted() {
  var self = this ;
  var container = self.el;
  var selectId = container.id;
  var dropdownId = selectId + "-dropdown";
  var resolveElements = function () {
    var dropdown = requireElement(container, "#" + dropdownId, "Dropdown container element", selectId);
    var found = dropdown.querySelector("#" + dropdownId + "-search");
    return {
            dropdown: dropdown,
            trigger: requireElement(dropdown, "#" + dropdownId + "-trigger", "Dropdown trigger element", selectId),
            menu: requireElement(dropdown, "#" + dropdownId + "-menu", "Dropdown menu element", selectId),
            search: !(found == null) && DomEl$GameDataCore.isHtmlInputElement(found) ? Caml_option.some(found) : undefined
          };
  };
  var initial = resolveElements();
  var search = initial.search;
  var state = {
    dropdown: initial.dropdown,
    trigger: initial.trigger,
    menu: initial.menu,
    search: initial.search,
    searchValue: search !== undefined ? Caml_option.valFromOption(search).value : "",
    searchFocused: false,
    width: "",
    top: "",
    left: "",
    visible: false
  };
  var storeElements = function () {
    var next = resolveElements();
    state.dropdown = next.dropdown;
    state.trigger = next.trigger;
    state.menu = next.menu;
    state.search = next.search;
  };
  var withSearch = function (action) {
    var search = state.search;
    if (search !== undefined) {
      return action(Caml_option.valFromOption(search));
    }
    
  };
  var updateVisibility = function () {
    if (state.visible) {
      return DomEl$GameDataCore.removeClass(state.menu, "hidden");
    } else {
      return DomEl$GameDataCore.addClass(state.menu, "hidden");
    }
  };
  var updateSize = function () {
    var style = state.menu.style;
    if (state.width === "") {
      style.width = "";
      style.minWidth = "";
      style.maxWidth = "";
      return ;
    }
    style.width = state.width;
    style.minWidth = state.width;
    var padding = Styles$GameDataCore.getSpacingSize() * 5.0;
    style.maxWidth = Menus$GameDataCore.px(Math.max(0.0, window.innerWidth - 2.0 * padding));
  };
  var updatePosition = function () {
    var style = state.menu.style;
    style.top = state.top;
    style.left = state.left;
  };
  var setMenuOffsets = function () {
    var offsets = Menus$GameDataCore.getMenuOffsets(container, state.trigger, state.menu, (function (width) {
            state.width = width;
            updateSize();
          }));
    state.top = Menus$GameDataCore.orEmpty(offsets.top);
    state.left = Menus$GameDataCore.orEmpty(offsets.left);
    updatePosition();
  };
  var match = Throttle$GameDataCore.make((function (searchEvent, value) {
          self.pushEvent(searchEvent, {
                value: value
              });
        }), 300);
  var destroyThrottle = match[1];
  var pushSearchTerm = match[0];
  var searchEventName = function () {
    var search = state.search;
    if (search === undefined) {
      return ;
    }
    var other = Caml_option.valFromOption(search).getAttribute("data-search-event");
    if ((other == null) || other === "" || (other == null)) {
      return ;
    } else {
      return Caml_option.some(other);
    }
  };
  var pushSearchValue = function () {
    var name = searchEventName();
    if (name !== undefined) {
      return pushSearchTerm(name, state.searchValue);
    }
    
  };
  var reset = function () {
    state.trigger.tabIndex = 0;
    state.searchValue = "";
    withSearch(function (search) {
          search.value = "";
          DomEl$GameDataCore.addClass(search, "hidden");
        });
    state.visible = false;
    updateVisibility();
    setMenuOffsets();
    pushSearchValue();
  };
  var revealSearch = function () {
    state.trigger.tabIndex = -1;
    withSearch(function (search) {
          DomEl$GameDataCore.removeClass(search, "hidden");
          search.focus();
        });
  };
  var searchHasFocus = function () {
    var match = document.activeElement;
    var match$1 = state.search;
    if (!(match == null) && match$1 !== undefined) {
      return match === Caml_option.valFromOption(match$1);
    } else {
      return false;
    }
  };
  var focusableItems = function () {
    return Array.from(state.dropdown.querySelectorAll(focusableSelector));
  };
  var focusIfElement = function (item) {
    if (item === undefined) {
      return ;
    }
    var found = Caml_option.valFromOption(item);
    if (DomEl$GameDataCore.isHtmlElement(found)) {
      found.focus();
      return ;
    }
    
  };
  var itemAt = function (items, index, fallback) {
    var item = Belt_Array.get(items, index);
    if (item !== undefined) {
      return Caml_option.some(Caml_option.valFromOption(item));
    } else {
      return Belt_Array.get(items, fallback);
    }
  };
  var moveFocus = function ($$event, forward) {
    DomEl$GameDataCore.addClass(document.body, "tabbing");
    $$event.preventDefault();
    var items = focusableItems();
    var active = document.activeElement;
    var activeIndex = (active == null) ? -1 : items.indexOf(active);
    if (forward) {
      return focusIfElement(itemAt(items, activeIndex + 1 | 0, 0));
    } else {
      return focusIfElement(itemAt(items, activeIndex - 1 | 0, items.length - 1 | 0));
    }
  };
  var onKeyContainer = function ($$event) {
    var key = $$event.key;
    if (key === "Escape") {
      state.visible = false;
      state.searchValue = "";
      withSearch(function (search) {
            search.value = "";
          });
      updateVisibility();
      var active = document.activeElement;
      if (!(active == null) && state.dropdown.contains(active)) {
        state.trigger.tabIndex = 0;
        state.trigger.focus();
      }
      return pushSearchValue();
    }
    if (typeableCharacters.includes(key.toLowerCase()) && !searchHasFocus()) {
      state.visible = true;
      state.searchValue = "";
      withSearch(function (search) {
            search.value = "";
          });
      revealSearch();
      updateVisibility();
      return setMenuOffsets();
    }
    if (key === "ArrowDown" || key === "ArrowRight") {
      return moveFocus($$event, true);
    }
    if (key === "ArrowUp" || key === "ArrowLeft") {
      return moveFocus($$event, false);
    }
    if (!(key === "Enter" || key === " ")) {
      return ;
    }
    $$event.preventDefault();
    var active$1 = document.activeElement;
    if (!(active$1 == null) && DomEl$GameDataCore.isHtmlElement(active$1)) {
      active$1.click();
      return ;
    }
    
  };
  var onClickTriggerOrSearch = function (_event) {
    state.visible = true;
    revealSearch();
    updateVisibility();
    setMenuOffsets();
  };
  var onFocusTrigger = function (_event) {
    revealSearch();
  };
  var onFocusOutContainer = function ($$event) {
    var related = $$event.relatedTarget;
    if (!(related == null) && !(DomEl$GameDataCore.isNode(related) && container.contains(related))) {
      return reset();
    }
    
  };
  var onClickOutside = function ($$event) {
    var target = $$event.target;
    if (!(target == null) && DomEl$GameDataCore.isNode(target) && container.contains(target)) {
      return ;
    } else {
      return reset();
    }
  };
  var onChangeSearch = function ($$event) {
    $$event.stopPropagation();
    var search = state.search;
    state.searchValue = search !== undefined ? Caml_option.valFromOption(search).value : "";
    pushSearchValue();
  };
  var onFocusSearch = function (_event) {
    state.searchFocused = true;
    state.trigger.tabIndex = -1;
    withSearch(function (search) {
          DomEl$GameDataCore.removeClass(search, "hidden");
        });
  };
  var onBlurSearch = function (_event) {
    state.searchFocused = false;
    if (state.searchValue === "") {
      state.trigger.tabIndex = 0;
      return withSearch(function (search) {
                  DomEl$GameDataCore.addClass(search, "hidden");
                });
    }
    
  };
  var onKeySearch = function ($$event) {
    var key = $$event.key;
    var horizontal = key === "ArrowLeft" || key === "ArrowRight";
    if (!state.visible && (key === "Tab" || horizontal)) {
      $$event.stopPropagation();
      return ;
    } else {
      if (key !== "Escape") {
        state.visible = true;
        updateVisibility();
        setMenuOffsets();
      }
      if (horizontal) {
        $$event.stopPropagation();
      }
      if ((key === "Enter" || key === "Space" || key === " ") && state.searchValue !== "") {
        $$event.stopPropagation();
        return ;
      } else {
        return ;
      }
    }
  };
  var onClickMenu = function ($$event) {
    $$event.stopPropagation();
    var match = container.getAttribute("data-multiple");
    var multiple;
    if (match == null) {
      multiple = false;
    } else {
      switch (match) {
        case "" :
        case "false" :
            multiple = false;
            break;
        default:
          multiple = true;
      }
    }
    if (!multiple) {
      state.visible = false;
      state.searchValue = "";
      withSearch(function (search) {
            search.value = "";
          });
      state.trigger.tabIndex = 0;
      state.trigger.focus();
      return updateVisibility();
    }
    
  };
  var onPreventDefault = function ($$event) {
    $$event.preventDefault();
  };
  var onReposition = function (_event) {
    setMenuOffsets();
  };
  var notPassive = {
    passive: false
  };
  var addListeners = function () {
    state.trigger.addEventListener("focus", onFocusTrigger, notPassive);
    state.trigger.addEventListener("click", onClickTriggerOrSearch, notPassive);
    withSearch(function (search) {
          search.addEventListener("click", onClickTriggerOrSearch, notPassive);
          search.addEventListener("keydown", onKeySearch, notPassive);
          search.addEventListener("keypress", onKeySearch, notPassive);
          search.addEventListener("input", onChangeSearch, notPassive);
          search.addEventListener("change", onChangeSearch, notPassive);
          search.addEventListener("search", onChangeSearch, notPassive);
          search.addEventListener("focusout", onPreventDefault, notPassive);
          search.addEventListener("focus", onFocusSearch, notPassive);
          search.addEventListener("blur", onBlurSearch, notPassive);
        });
    state.menu.addEventListener("click", onClickMenu, notPassive);
    container.addEventListener("focusout", onFocusOutContainer, notPassive);
    container.addEventListener("keydown", onKeyContainer, notPassive);
    container.addEventListener("keypress", onKeyContainer, notPassive);
    window.addEventListener("click", onClickOutside, notPassive);
    window.addEventListener("scroll", onReposition, {
          capture: true,
          passive: true
        });
    window.addEventListener("resize", onReposition, notPassive);
  };
  var removeListeners = function () {
    state.trigger.removeEventListener("focus", onFocusTrigger);
    state.trigger.removeEventListener("click", onClickTriggerOrSearch);
    withSearch(function (search) {
          search.removeEventListener("click", onClickTriggerOrSearch);
          search.removeEventListener("keydown", onKeySearch);
          search.removeEventListener("keypress", onKeySearch);
          search.removeEventListener("input", onChangeSearch);
          search.removeEventListener("change", onChangeSearch);
          search.removeEventListener("search", onChangeSearch);
          search.removeEventListener("focusout", onPreventDefault);
          search.removeEventListener("focus", onFocusSearch);
          search.removeEventListener("blur", onBlurSearch);
        });
    state.menu.removeEventListener("click", onClickMenu);
    container.removeEventListener("focusout", onFocusOutContainer);
    container.removeEventListener("keydown", onKeyContainer);
    container.removeEventListener("keypress", onKeyContainer);
    window.removeEventListener("click", onClickOutside);
    window.removeEventListener("scroll", onReposition, true);
    window.removeEventListener("resize", onReposition);
  };
  var syncSearchState = function () {
    withSearch(function (search) {
          search.value = state.searchValue;
        });
    if (state.searchValue !== "" || state.searchFocused) {
      state.trigger.tabIndex = -1;
      withSearch(function (search) {
            DomEl$GameDataCore.removeClass(search, "hidden");
          });
    } else {
      state.trigger.tabIndex = 0;
      withSearch(function (search) {
            DomEl$GameDataCore.addClass(search, "hidden");
          });
    }
    if (state.searchFocused) {
      return withSearch(function (search) {
                  search.focus();
                });
    }
    
  };
  var resizeObserver = new ResizeObserver(setMenuOffsets);
  resizeObserver.observe(state.trigger);
  var teardown = function () {
    removeListeners();
    resizeObserver.disconnect();
    destroyThrottle();
  };
  addListeners();
  self._selectDropdownHandlers = {
    storeElements: storeElements,
    addListeners: addListeners,
    removeListeners: removeListeners,
    syncSearchState: syncSearchState,
    updateVisibility: updateVisibility,
    updateSize: updateSize,
    updatePosition: updatePosition,
    teardown: teardown
  };
}

function updated() {
  var self = this ;
  var handlers = self._selectDropdownHandlers;
  handlers.removeListeners();
  handlers.storeElements();
  handlers.addListeners();
  handlers.syncSearchState();
  handlers.updateVisibility();
  handlers.updateSize();
  handlers.updatePosition();
}

function destroyed() {
  var self = this ;
  self._selectDropdownHandlers.teardown();
}

var selectDropdown = {
  mounted: mounted,
  updated: updated,
  destroyed: destroyed
};

export {
  focusableSelector ,
  typeableCharacters ,
  requireElement ,
  mounted ,
  updated ,
  destroyed ,
  selectDropdown ,
}
/* mounted Not a pure module */
